export default function stripUndefined(obj: Object): Object {
  return JSON.parse(JSON.stringify(obj))
}
